import { hasPermissionGuard } from "../../../core/guards";
import { Constants } from "../../../shared/constants/constants";
import { PermissionAction } from "../../../shared/constants/enums";

export const viewAuditActualsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AUDIT_DATA,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAuditActualsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AUDIT_DATA,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
